<template>
    <div>
        <section class="padding-vertical-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <ul class="matches">
                            <li style="list-style: none" class="align-items-lg-center align-items-center justify-content-between text-center">
                                <div>
                                    <h2>Error interno</h2>
                                    <p>Ha ocurrido un error interno, puede que se solucione recargando la página.</p>
                                    <button class="btn" @click="reload()">Recargar</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        mounted() {
            if(this.$route.params.error == null) {
                this.$router.push({name: "front.home"});
            }
        },
        methods: {
            reload() {
                if(process.browser) {
                    window.location.reload(true);
                }
            }
        },
    }
</script>
